import { Box, TextField, MenuItem, Grid } from '@mui/material';
import type {
  InvestmentType,
  OpportunityFilters as OpportunityFiltersType,
} from '@inversor-hub/types';
import ProvinceSelector from '@/components/form/ProvinceSelector';
import { investmentTypeLabels } from '@/features/investments/constants';

interface OpportunityFiltersProps {
  filters: OpportunityFiltersType;
  onFilterChange: (filters: OpportunityFiltersType) => void;
}

const OpportunityFilters = ({ filters, onFilterChange }: OpportunityFiltersProps) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <ProvinceSelector
            value={filters.province || ''}
            onChange={(value) => onFilterChange({ ...filters, province: value || undefined })}
            label="Provincia"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            select
            fullWidth
            label="Habitaciones"
            value={filters.rooms ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              onFilterChange({ ...filters, rooms: value === '' ? undefined : parseInt(value) });
            }}
            size="small"
          >
            <MenuItem value="">Todas</MenuItem>
            {[1, 2, 3, 4, 5, 6].map((num) => (
              <MenuItem key={num} value={num}>
                {num}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            select
            fullWidth
            label="Baños"
            value={filters.bathrooms ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              onFilterChange({ ...filters, bathrooms: value === '' ? undefined : parseInt(value) });
            }}
            size="small"
          >
            <MenuItem value="">Todos</MenuItem>
            {[1, 2, 3, 4].map((num) => (
              <MenuItem key={num} value={num}>
                {num}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            select
            fullWidth
            label="Tipo de inversión"
            value={filters.type || ''}
            onChange={(e) => {
              const value = e.target.value;
              onFilterChange({
                ...filters,
                type: value === '' ? undefined : (value as InvestmentType),
              });
            }}
            size="small"
          >
            <MenuItem value="">Todos</MenuItem>
            {Object.entries(investmentTypeLabels).map(([value, label]) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OpportunityFilters;
